import { z } from "zod";
import { LookupListPage } from "./LookupListPage";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface Row { stmtDeliveryMethodCode: string; description: string; deleted: boolean; }
const schema = z.object({
  stmtDeliveryMethodCode: z.string().min(1).max(20),
  description: z.string().min(1).max(100),
  deleted: z.boolean(),
});
type Form = z.infer<typeof schema>;

export function StmtDeliveryMethodsPage() {
  return <LookupListPage<Row, Form>
    title="Statement delivery methods"
    apiPath="/api/lookups/stmt-delivery-methods"
    schema={schema}
    rowKey={(r) => r.stmtDeliveryMethodCode}
    columns={[
      { id: "code", header: "Code", accessor: (r) => r.stmtDeliveryMethodCode },
      { id: "desc", header: "Description", accessor: (r) => r.description },
    ]}
    toFormValues={(r) => ({ stmtDeliveryMethodCode: r.stmtDeliveryMethodCode, description: r.description, deleted: r.deleted })}
    toApiBody={(f) => f}
    blankFormValues={{ stmtDeliveryMethodCode: "", description: "", deleted: false }}
    fields={(f) => (
      <div className="space-y-3">
        <div><Label htmlFor="c">Code</Label><Input id="c" {...f.register("stmtDeliveryMethodCode")} /></div>
        <div><Label htmlFor="d">Description</Label><Input id="d" {...f.register("description")} /></div>
        <Button type="submit">Save</Button>
      </div>
    )}
  />;
}
